// FixedHeightVirtualTable.jsx
import React, { useRef, useEffect } from 'react'
import { useVirtualizer } from '@tanstack/react-virtual'
import { flexRender } from '@tanstack/react-table'

export default function FixedHeightVirtualTable({
  rows = [],
  containerHeight = 600,
  onVirtualizerCreated,
  prepareRow,
  activeMajor, // not strictly used in this snippet
}) {
  const parentRef = useRef(null)
  const rowCount = rows.length || 0

  // Create the virtualizer
  const rowVirtualizer = useVirtualizer({
    count: rowCount,
    getScrollElement: () => parentRef.current,
    measureElement: (el) => el.offsetHeight,
    estimateSize: (index) => {
      const row = rows[index]
      // If it's a "major header" row, guess ~60px, else ~40px
      const isHeader = row?.original?.onetSOC?.endsWith('0000')
      return isHeader ? 60 : 40
    },
    overscan: 3,
  })

  // Expose the virtualizer to the parent
  useEffect(() => {
    if (onVirtualizerCreated && parentRef.current) {
      onVirtualizerCreated(rowVirtualizer)
    }
  }, [rowVirtualizer, onVirtualizerCreated])

  const virtualItems = rowVirtualizer.getVirtualItems()
  const totalSize = rowVirtualizer.getTotalSize()

  return (
    <div
      ref={parentRef}
      style={{
        width: '100%',
        height: `65vh`,
overflow: 'auto',
overflowX: 'clip',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'relative',
          height: `${totalSize}px`,
          width: '1135px',
          paddingLeft: 24,
        paddingRight: 24,
        boxSizing: 'border-box',
    
        }}
      >
        {virtualItems.map((virtualRow) => {
          const index = virtualRow.index
          const row = rows[index]
          if (!row) return null

          // use row.id as the unique key
          const rowKey = row.id
          const isMajorHeader = row.original?.onetSOC?.endsWith('0000')

       // Set a background color based on whether it's a major header.
          // For example, a creamsicle orange/amber for major headers.
          const bgColor = isMajorHeader
            ? '#E3E3E3' // creamsicle orange/amber shade (adjust as needed)
            : virtualRow.index % 2 === 0
              ? '#fff'
              : '#fefefe'


          return (
            <div
              key={rowKey}
              data-index={index}
              ref={(el) => {
                if (el) {
                  rowVirtualizer.measureElement(el)
                }
              }}
              style={{
                position: 'absolute',
                top: 0,
                transform: `translateY(${virtualRow.start}px)`,
                width: '100%',
                background: bgColor,
                borderBottom: isMajorHeader ? undefined : '1px solid #eee',
                marginLeft: '-15px',
                minHeight: isMajorHeader ? '60px' : '40px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                }}
              >
                {/* For each visible cell in this row */}
                {row.getVisibleCells().map((cell) => {
  // Get the fixed size (if any) from the column definition.
  const colWidth = cell.column.getSize?.() || 150
  // Check if this is the responsive column.
  const isResponsive = cell.column.id === 'onetTitle'
  
  prepareRow && prepareRow(row)
  return (
    <div
      key={cell.id}
      style={{
        // For the responsive column, allow it to flex
        // so it takes up available space up to its max width.
        flex: isResponsive ? '1 1 auto' : `0 0 ${colWidth}px`,
        minWidth: colWidth,
        // Optionally, you could add maxWidth for the responsive column
        ...(isResponsive && { maxWidth: '220px' }),
        padding: '0 4px',
      }}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </div>
  )
})}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}